<template>
  <a-layout class="container">
    <!-- 左侧区域 -->

    <hina-base-slider :currentMenuKey="curMenuKey" />

    <!-- 主体区域 -->
    <a-layout>
      <!-- 头部 -->
      <hina-user-info :user="objUserInfo" />

      <a-layout-content>
        <!-- 位置 -->
        <hina-bread-crumb :link="[]" />

        <!-- 主体 -->
        <div class="wrapper" id="Home">
          <div class="wrap">
            <div class="hd">统计信息</div>
            <div class="bd">
              <a-row>
                <a-col style="width: 20%">
                  <div class="counter-box" @click="loadStaffList('2')">
                    <div class="txt">{{ intMemberCount }}</div>
                    <div class="lab">企业会员</div>
                  </div>
                </a-col>
                <a-col style="width: 20%">
                  <div class="counter-box" @click="loadStaffList('1')">
                    <div class="txt">{{ inviteUserCount }}</div>
                    <div class="lab">会员汇总</div>
                  </div>
                </a-col>
                <!-- <a-col style="width: 20%">
                  <div class="counter-box">
                    <div class="txt">{{ couponCode }}</div>
                    <div class="lab">开药卡线上使用数量</div>
                  </div>
                </a-col> -->
                <a-col style="width: 20%">
                  <div class="counter-box" @click="loadStaffList('3')">
                    <div class="txt">{{ yearMembershipCard }}</div>
                    <div class="lab">实体卡激活数量</div>
                  </div>
                </a-col>
                <a-col style="width: 20%">
                  <div class="counter-box">
                    <div class="txt">{{ lngMoneyTotal }}</div>
                    <div class="lab">累计充值金额</div>
                  </div>
                </a-col>
                <a-col style="width: 20%">
                  <div class="counter-box">
                    <div class="txt">{{ lngMoneyBalance }}</div>
                    <div class="lab">职员额度余额</div>
                  </div>
                </a-col>
                <a-col style="width: 20%">
                  <div class="counter-box">
                    <div class="txt">{{ lngMoneyCanset }}</div>
                    <div class="lab">账户余额</div>
                  </div>
                </a-col>
              </a-row>
            </div>
          </div>
          <div class="wrap">
            <div class="hd">{{crtTitle}}</div>
            <div class="trans-table">
              <a-table
                bordered
                :columns="arrTabCol"
                :data-source="arrTabRow"
                :row-key="record => record.id"
                :pagination="pagination"
                :loading="loading"
                @change="handleTableChange"
              >
                <template slot="useFlagSlot" slot-scope="row">
                  <div>
                    <a-tag v-if="row" color="green">已使用</a-tag>
                    <a-tag v-if="!row" color="red">未使用</a-tag>
                  </div>
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import HinaBaseSlider from 'components/HinaBaseSlider/HinaBaseSlider'
import HinaUserInfo from 'components/HinaUserInfo/HinaUserInfo'
import HinaBreadCrumb from 'components/HinaBreadCrumb/HinaBreadCrumb'

export default {
  name: 'Home',
  components: {
    HinaBaseSlider,
    HinaUserInfo,
    HinaBreadCrumb
  },
  data() {
    return {
      objUserInfo: {},
      curMenuKey: ['home'],

      arrTabCol: [],
      arrTabRow: [],
      intUserId: 0,

      intMemberCount: '', // 企业总数统计
      lngMoneyTotal: '', // 企业累计充值
      lngMoneyBalance: '', // 当前账户余额
      lngMoneyCanset: '', // 企业未分配金额
      inviteUserCount: '', // 会员人数
      couponCode: '', // 优惠码
      yearMembershipCard: '', // 年会员实体卡
      arr: [
        { value: 1, name: '充值' },
        { value: 2, name: '在线充值' },
        { value: 3, name: '后台充值' },
        { value: 4, name: '退款' },
        { value: 5, name: '提现' },
        { value: 6, name: '支付' },
        { code: 7, value: '邀请购买年会员奖励' },
        { code: 8, value: '订单分成奖励' }
      ],
      cardParams: {
        pageSize: '10',
        pageNumber: '1',
        enterpriseInformationId: '' //企业卡号
      }, // 获取实体卡列表params
      showDateType: '1', // 会员汇总 -> 1, 企业会员 -> 2, 实体卡激活数量 -> 3,
      loading: false, // 分页loading
      crtTitle: '会员汇总',
      pagination: {
        pageSize: 10,
        total: 0,
        current: 1
      }, // 分页
    }
  },
  created: function () {
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.cardParams.enterpriseInformationId = userInfo.id
  },
  mounted: function() {
    // 装载用户信息
    this.objUserInfo = this.$store.state.userInfo || JSON.parse(localStorage.getItem('userInfo'))
    // console.log('获取用户缓存：', this.objUserInfo)
    // 加载统计信息
    this.loadDataCounter()

    this.loadDataMoneyTotal()

    this.loadDataMoneyCanset()

    this.loadDataMoneyBalance()

    // this.loadDataTrans()
    this.loadInviteUserCount()
    this.loadCouponCode()
    this.loadYearMembershipCard()
    this.loadStaffList('1')
    // this.getStaffCount();
  },
  methods: {
    //查询列表
    loadStaffList(e) {
      // e 参数解析：会员汇总 -> 1, 企业会员 -> 2, 实体卡激活数量 -> 3,
      if (this.showDateType != e) {
        this.cardParams.pageNumber = 1
      }
      this.showDateType = e
      let params = {
        pageNumber: this.cardParams.pageNumber,
        pageSize: this.cardParams.pageSize,
      }

      if (e == '1') {
        this.crtTitle = '会员汇总'
        this.$get('/enterpriseUser/getInviteUserInfo', params).then(res => {
          this.arrTabCol = [
            {
              title: '用户昵称',
              dataIndex: 'name'
            },
            {
              title: '手机号',
              dataIndex: 'phone'
            },
            {
              title: '收益',
              dataIndex: 'money'
            },
            {
              title: '邀请时间',
              dataIndex: 'inviterTime'
            }
          ]
          this.arrTabRow = res.result.records
          this.loading = false
          
          this.pagination = {
              current: res.result.current,
              pageSize: res.result.size,
              total: res.result.total
          }
        })
      }
      if (e == '2') {
        this.crtTitle = '企业会员'
        this.$get('enterpriseUser/getInviteUserAll', params).then(res => {
          this.arrTabCol = [
            {
              title: '手机号',
              dataIndex: 'phone'
            },
            {
              title: '用户名称',
              dataIndex: 'name'
            },
            {
              title: '客户池人数',
              dataIndex: 'inviterCount'
            },
            {
              title: '累计收益',
              dataIndex: 'money'
            },
            {
              title: '邀请时间',
              dataIndex: 'inviterTime'
            }
          ]
          this.arrTabRow = res.result.records
          this.pagination = {
            current: res.result.current,
            pageSize: res.result.size,
            total: res.result.total
          }
          this.loading = false
        })
      }
      if (e == '3') {
        this.crtTitle = '实体卡激活数量'
        this.$get('/physical/card/listAll', this.cardParams).then(res => {
          this.arrTabCol = [
            {
              title: '用户名称',
              dataIndex: 'name',
              width: 200
            },
            {
              title: '电话号码',
              dataIndex: 'phone'
            },
            {
              title: '卡号',
              dataIndex: 'cardId'
            },
            {
              title: '批次',
              dataIndex: 'batch'
            },
            {
              title: '兑换码',
              dataIndex: 'cardVoucher'
            },
            {
              title: '使用状态',
              dataIndex: 'useFlag',
              scopedSlots: { customRender: 'useFlagSlot' }
            },
            {
              title: '使用时间',
              dataIndex: 'useDate'
            },
            {
              title: '过期时间',
              dataIndex: 'expirationTime'
            },
            {
              title: '实体卡分类ID',
              dataIndex: 'physicalCardCategoryId'
            }
          ]
          if (res.success) {
            this.arrTabRow = res.result.records
            this.pagination = {
              current: res.result.current,
              pageSize: res.result.size,
              total: res.result.total
            }
            this.loading = false
          }
        })
      }
    },
    // 获取年会员实体卡
    loadYearMembershipCard() {
      let params = {
        enterpriseInformationId: this.$store.state.userInfo.id
      }

      // this.$get("/physical/card/countNum", {params})
      let url = '/physical/card/countNum?enterpriseInformationId=' + params.enterpriseInformationId
      this.$get(url, {}).then(res => {
        if (res.code == 200) {
          this.yearMembershipCard = res.result
        }
      })
    },
    // 分页
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.cardParams.pageNumber = pagination.current
      this.loading = true
      this.loadStaffList(this.showDateType)
    },

    // 获取优惠码使用量
    loadCouponCode() {
      this.$get('/couponYard/getCountNum', {}).then(res => {
        console.log('获取优惠码使用量', res)
        if (res.code == 200) {
          this.couponCode = res.result
        }
      })
    },
    // 获取会员人数接口
    loadInviteUserCount() {
      this.$get('enterpriseInformation/getInviteUserCount', {})
        .then(res => {
          let objRes = res
          this.inviteUserCount = objRes.result
        })
        .catch(e => {})
    },
    loadDataCounter: function() {
      this.$get('enterpriseUser/count', { id: this.objUserInfo.id })
        .then(res => {
          let objRes = res
          this.intMemberCount = objRes.result
        })
        .catch(e => {})
    },
    //累计充值金额
    loadDataMoneyTotal: function() {
      this.$get('enterpriseInformation/totalRecharge', {
        id: this.objUserInfo.id
      })
        .then(res => {
          let objRes = res
          this.lngMoneyTotal = objRes.result
        })
        .catch(e => {})
    },
    //当前账户余额
    loadDataMoneyBalance: function() {
      this.$get('enterpriseUser/allocatedBalance', { id: this.objUserInfo.id })
        .then(res => {
          let objRes = res
          this.lngMoneyBalance = objRes.result
        })
        .catch(e => {})
    },
    //企业未分配金额
    loadDataMoneyCanset: function() {
      this.$get('enterpriseInformation/unallocatedBalance', {
        id: this.objUserInfo.id
      })
        .then(res => {
          let objRes = res
          this.lngMoneyCanset = objRes.result
        })
        .catch(e => {})
    },
    //最近流水
    loadDataTrans: function() {
      let params = {
        uid: this.objUserInfo.id,
        sort: 'create_time',
        order: 'desc'
      }
      this.$get('enterpriseTransaction/list', params)
        .then(res => {
          let objRes = res
          console.log(res.result.records)
          var records = objRes.result.records
          for (let i = 0; i < records.length; i++) {
            this.arrTabRow.push({
              id: records[i].id,
              money: records[i].money,
              createTime: records[i].createTime,
              type: this.getLabelByValue(records[i].type),
              remark: records[i].remark,
              newMoney: records[i].newMoney
            })
          }
        })
        .catch(e => {})
    },
    //通过value值获取name值
    getLabelByValue(value) {
      let name = ''
      this.arr.forEach(item => {
        if (item.value === value) {
          name = item.name
        }
      })
      return name
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  .wrap {
    margin: 20px 0 0;
    padding: 0 24px;
    background: #fff;
    min-height: 240px;

    .hd {
      height: 72px;
      line-height: 72px;
      color: #333;
      font-weight: 600;
      font-size: 18px;
      position: relative;
      margin-bottom: 30px;

      &::after {
        position: absolute;
        content: '';
        height: 1px;
        background: rgba(0, 0, 0, 0.1);
        left: 0;
        right: 0;
        bottom: 0;
      }
    }

    .trans-table {
      padding: 0 0 40px;
    }

    .counter-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 20px 0;
      margin: 0 0 40px;

      .lab {
        font-size: 18px;
        height: 30px;
        line-height: 30px;
        color: #999;
      }

      .txt {
        font-size: 36px;
        height: 60px;
        line-height: 60px;
        color: #444;
      }
    }

    .ant-row {
      display: flex;
      .ant-col {
        .counter-box {
          position: relative;

          &::after {
            position: absolute;
            content: '';
            right: 0;
            top: 15px;
            bottom: 15px;
            width: 1px;
            background: rgba(0, 0, 0, 0.1);
          }
        }
      }

      .ant-col:last-of-type {
        .counter-box {
          &::after {
            display: none;
          }
        }
      }
    }
  }

  .wrap:first-of-type {
    margin: 0;
  }
}
</style>
